import React, { PropsWithChildren, ReactNode } from 'react';

import { Box, Divider, Stack, Typography } from '@mui/material';

type Props = PropsWithChildren<{
  title: string | ReactNode;
  startIcon?: ReactNode;
}>;

export default function PageSubheader({ title, children, startIcon }: Props) {
  return (
    <Box pt={1} pb={2}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {startIcon}

        <Typography flex={1} component="h2" color="grey.800" fontSize="1.8rem" fontWeight={500} gutterBottom>
          {title}
        </Typography>

        {children && <Box>{children}</Box>}
      </Stack>

      <Divider />
    </Box>
  );
}
